export default function initSolarSolutions() {
    const solarSolutionsSections = document.querySelectorAll("[data-solar-solutions]");

    solarSolutionsSections.forEach((section) => {
        const tabs = section.querySelectorAll("[data-solar-tab]");

        const medias = section.querySelectorAll("[data-solar-media]");

        const panels = section.querySelectorAll("[data-solar-panel]");

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                const index = tab.dataset.solarTab;

                tabs.forEach((item) => {
                    const active = item.dataset.solarTab === index;

                    item.classList.toggle("is-active", active);

                    item.setAttribute("aria-expanded", active ? "true" : "false");
                });

                medias.forEach((media) => {
                    media.classList.toggle("is-active", media.dataset.solarMedia === index);
                });

                panels.forEach((panel) => {
                    panel.classList.toggle("is-active", panel.dataset.solarPanel === index);
                });
            });
        });
    });
}
